'use strict';

import useModalProps from "../../hooks/useModalProps";
import LandingRequestFormContainer from "../../containers/LandingRequestFormContainer";
import { SocialIcon } from "../../components/ui/icons";

function LandingHotelRequestFormModal ( {initialPhone = '', ...props} )
{
    const MODES = {form: 'form', success: 'success'}

    const { goals, fields: initialFields, data, mode: initialMode, showCheckboxMedia, links } = useModalProps ( props.formId || 'reactLandingHotelRequestFormModal', props, { data: {}, mode: MODES.form } );
    const [mode, setMode] = React.useState(MODES.form);
    const [fields, setFields] = React.useState(props.fields) // Сохраняем в стейт, чтобы при открытии модалки форма не моргала

    React.useEffect(() => {
        initialFields && setFields(initialFields);
        initialMode in MODES && setMode(initialMode);
    }, [ initialMode, initialFields ])

    const showFlagSelect = data.show_flag_select !== undefined ? data.show_flag_select : true;

    const handleSuccessSubmit = () => {
        setMode(MODES.success);
        setTimeout(() => {
            setMode(MODES.form);
            $.fancybox.close();
        }, 3000);
    }

    return <div className={data.class || "hotel-order"}>

        {data.show_close && <a data-fancybox-close="" className="order-modal__close">{__('barometer.close')}</a>}

        {mode === MODES.success && <div className="success-modal__title">
            <i className="icon-check2"></i>
            <h3>{__('hotels.thanks')}</h3>
            <span dangerouslySetInnerHTML={{__html: __('request.form.success.message')}}/>
        </div>}

        {mode === MODES.form && <div className="sf-row">
            <div className="sf-text">
                <h3>
                    {data.red_title && <span>{data.red_title}</span>}
                    {data.red_title && <br/>}
                    <div>{data.main_title || __('hotels.requestForHotel')}</div>
                    {data.hotel && data.hotel}
                    {data.title && <span>{data.title}</span>}
                </h3>
                <p>{data.description || __('hotels.leaveRequestAndWeContact')}</p>
                {/* Возможно, устарел вывод по ключам */}
                {links && typeof links === 'object' && !(links instanceof Array) && <div className="sf-social">
                    <div className="sf-social__row">
                        {links.telegram && <a href={links.telegram} target="_blank"><SocialIcon type="telegram" /></a>}
                        {links.rythm && <a href={links.rythm} target="_blank"><SocialIcon type="rythm" /></a>}
                        {links.dzen && <a href={links.dzen} target="_blank"><SocialIcon type="dzen" /></a>}
                        {links.vkontakte && <a href={links.vkontakte} target="_blank"><SocialIcon type="vkontakte" /></a>}
                        {links.youtube && <a href={links.youtube} target="_blank"><SocialIcon type="youtube" /></a>}
                        {links.instagram && <a href={links.instagram} target="_blank"><SocialIcon type="instagram" /></a>}
                        {links.threads && <a href={links.threads} target="_blank"><SocialIcon type="threads" /></a>}
                        {links.linkedin && <a href={links.linkedin} target="_blank"><SocialIcon type="linkedin" /></a>}
                        <span dangerouslySetInnerHTML={{__html: __('form.info.socials.description')}}/>
                    </div>
                </div>}
                {links && links instanceof Array && links.length > 0 && <div className="sf-social">
                    <div className="sf-social__row">
                        {links.map(item => <a key={item.type} href={item.link} target="_blank"><SocialIcon type={item.type} /></a>)}
                        <span dangerouslySetInnerHTML={{__html: __('form.info.socials.description')}}/>
                    </div>
                </div>}
            </div>
            <LandingRequestFormContainer
                landingName={props.landingName}
                url={props.url}
                goals={goals || []}
                fields={fields || []}
                data={data || {}}
                useAnimation={false}
                onSuccessSubmit={handleSuccessSubmit}
                showCheckboxMedia={showCheckboxMedia}
                showFlagSelect={showFlagSelect}
                initialPhone={initialPhone}
            />
        </div>}
    </div>
}

window.LandingHotelRequestFormModal = LandingHotelRequestFormModal
